module.exports = __webpack_public_path__ + "static/media/taalunie.ab24d6e3.png";